import { kebabCase } from "../..";
var PREFIX_SEPARATOR = '-';
var PREFIX_ELEMENT = '--';
var PREFIX_MODIFIER = '__';
var makeClassName = function(prefix, block, element, modifier) {
    return kebabCase("".concat(prefix ? "".concat(prefix) : '').concat(prefix && block ? PREFIX_SEPARATOR : '').concat(block ? "".concat(block) : '').concat(element ? "".concat(PREFIX_ELEMENT).concat(element) : '').concat(modifier ? "".concat(PREFIX_MODIFIER).concat(modifier) : ''));
};
export default makeClassName;
